import { Component, OnInit, OnDestroy } from '@angular/core';



export class NavbarGuestComponent { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/navbar/guest/navbar-guest.component.ts